// Mints and refreshes the 15-minute Player's Secret Corner token, called only from the
// SecretCorner page itself (the parent frame) — never sent into the iframe as anything
// but a postMessage payload. See imp_mds/PLAYERS_SECRET_CORNER_PLAN.md §5.
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

function getAccessToken(): string | null {
  const storageType = localStorage.getItem('auth_storage_type');
  const storage = storageType === 'session' ? sessionStorage : localStorage;
  return storage.getItem('access_token');
}

export async function mintCornerToken(): Promise<string> {
  const res = await axios.post(
    `${API_BASE_URL}/api/v1/players/session`,
    {},
    { headers: { Authorization: `Bearer ${getAccessToken()}` } }
  );
  return res.data.token;
}

export function secretCornerAppUrl(): string {
  return `${API_BASE_URL}/players/app/`;
}
